import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, ViewRef, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';

import { AppStateService } from "src/app/core-module/services/app-state.service";
import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDataStateService } from "../../../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
@Component({
  standalone: false,
  selector: "app-line-switch",
  templateUrl: "./line-switch.component.html",
  styleUrls: ["./line-switch.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LineSwitchComponent
  extends FieldType
  implements OnInit, OnDestroy {
  @Input() field;
  column: LegacyAny;
  featureVersion: LegacyAny;
  properties: LegacyAny;
  ngModelval: LegacyAny = [];
  inputError: LegacyAny = [];
  quickConfigvalue: boolean;
  quickConfigCustomCSS: string;
  setQuickConfig: string;
  HighVLevelNormal: LegacyAny;
  lineswitchHighVLevelMin;
  lineswitchHighVLevelMax;
  HighVLevelValue;
  HighVLevelDisplayValue: number;
  lineswitchHighVOption;
  lineswitchLowVLevel: LegacyAny;
  lineswitchLowVLevelMin: LegacyAny;
  lineswitchLowVLevelMax: LegacyAny;
  lineswitchLowVLevelValue: LegacyAny;
  lineswitchLowVLevelOption: { floor: LegacyAny; ceil: LegacyAny };
  lineswitchFadeUpTime: LegacyAny;
  lineswitchFadeUpTimeMin: LegacyAny;
  lineswitchFadeUpTimeMax: LegacyAny;
  lineswitchFadeUpTimeValue: LegacyAny;
  lineswitchFadeUpTimeOption: { floor: LegacyAny; ceil: LegacyAny };
  lineswitchFadeDownTimeOption: { floor: LegacyAny; ceil: LegacyAny };
  lineswitchFadeDownTimeMax: LegacyAny;
  lineswitchFadeDownTimeMin: LegacyAny;
  lineswitchFadeDownTime: LegacyAny;
  lineswitchFadeDownValue: LegacyAny;
  lineswitchOffDelayTimeMax: LegacyAny;
  lineswitchOffDelayTimeMin: LegacyAny;
  lineswitchOffDelayTime: LegacyAny;
  lineswitchOffDelayValue: LegacyAny;
  lineswitchOffDelayTimeOption: { floor: LegacyAny; ceil: LegacyAny };
  lineswitch2ndInactiveDimLevelMax: LegacyAny;
  lineswitch2ndInactiveDimLevelMin: LegacyAny;
  lineswitch2ndInactiveDimLevelOption: { floor: LegacyAny; ceil: LegacyAny };
  lineswitch2ndInactiveDimLevelValue: LegacyAny;
  lineswitch2ndInactiveDimLevel: LegacyAny;
  lineswitch2ndInactiveLevelDelayTimeMin: LegacyAny;
  LineSwitchEnabled: LegacyAny;
  lineswitch2ndInactiveLevelDelayTimeMax: LegacyAny;
  lineswitch2ndInactiveLevelDelayTimeValue: LegacyAny;
  lineswitch2ndInactiveLevelDelayTimeOption: { floor: LegacyAny; ceil: LegacyAny };
  lineswitch2ndInactiveLevelDelayTime: LegacyAny;
  isLineSwitchEnabled: LegacyAny;
  inactiveLevelEnabled;
  lineSwitchDefaultColor;
  lineswitchCreateFile: boolean;
  show2ndInactiveLevelEnabled: boolean = true;
  show2ndInactiveDimLevel: boolean = true;
  show2ndInactiveLevelDelayTime: boolean = true;
  isEdited: LegacyAny;
  isResetLineSwitch: boolean = false;
  isInitialLoad: boolean = true;
  lineSwitchSub: Subscription;
  getLineSwitchDefaultValueSub: Subscription;
  corridordisbaled: LegacyAny;
  isExternalRset: LegacyAny;

  lineswitchLowVLevelDisplayValue: number;
  lineswitchFadeUpTimeDisplayValue: number;
  lineswitchFadeDownDisplayValue: number;
  lineswitchOffDelayDisplayValue: number;
  lineswitch2ndInactiveDimLevelDisplayValue: number;
  lineswitch2ndInactiveLevelDelayDisplayValue: number;

  private fieldConfig: { [key: string]: { modelKey: string; displayKey: string; minKey: string; maxKey: string; valueKey: string; ngModelKey?: string } } = {
    'HighVLevel': {
      modelKey: 'HighVLevelValue',
      displayKey: 'HighVLevelDisplayValue',
      minKey: 'lineswitchHighVLevelMin',
      maxKey: 'lineswitchHighVLevelMax',
      valueKey: 'HighVLevelValue',
      ngModelKey: 'HighVLevelValue'
    },
    'LowVLevel': {
      modelKey: 'lineswitchLowVLevelValue',
      displayKey: 'lineswitchLowVLevelDisplayValue',
      minKey: 'lineswitchLowVLevelMin',
      maxKey: 'lineswitchLowVLevelMax',
      valueKey: 'lineswitchLowVLevelValue',
      ngModelKey: 'lineswitchLowVLevelValue'
    },
    'FadeUpTime': {
      modelKey: 'lineswitchFadeUpTimeValue',
      displayKey: 'lineswitchFadeUpTimeDisplayValue',
      minKey: 'lineswitchFadeUpTimeMin',
      maxKey: 'lineswitchFadeUpTimeMax',
      valueKey: 'lineswitchFadeUpTimeValue',
      ngModelKey: 'lineswitchFadeUpTimeValue'
    },
    'FadeDownTime': {
      modelKey: 'lineswitchFadeDownValue',
      displayKey: 'lineswitchFadeDownDisplayValue',
      minKey: 'lineswitchFadeDownTimeMin',
      maxKey: 'lineswitchFadeDownTimeMax',
      valueKey: 'lineswitchFadeDownValue',
      ngModelKey: 'lineswitchFadeDownValue'
    },
    'SwitchOffDelayTime': {
      modelKey: 'lineswitchOffDelayValue',
      displayKey: 'lineswitchOffDelayDisplayValue',
      minKey: 'lineswitchOffDelayTimeMin',
      maxKey: 'lineswitchOffDelayTimeMax',
      valueKey: 'lineswitchOffDelayValue',
      ngModelKey: 'lineswitchOffDelayValue'
    },
    '2ndInactiveDimLevel': {
      modelKey: 'lineswitch2ndInactiveDimLevelValue',
      displayKey: 'lineswitch2ndInactiveDimLevelDisplayValue',
      minKey: 'lineswitch2ndInactiveDimLevelMin',
      maxKey: 'lineswitch2ndInactiveDimLevelMax',
      valueKey: 'lineswitch2ndInactiveDimLevelValue',
      ngModelKey: 'lineswitch2ndInactiveDimLevelValue'
    },
    '2ndInactiveLevelDelayTime': {
      modelKey: 'lineswitch2ndInactiveLevelDelayTimeValue',
      displayKey: 'lineswitch2ndInactiveLevelDelayDisplayValue',
      minKey: 'lineswitch2ndInactiveLevelDelayTimeMin',
      maxKey: 'lineswitch2ndInactiveLevelDelayTimeMax',
      valueKey: 'lineswitch2ndInactiveLevelDelayTimeValue',
      ngModelKey: 'lineswitch2ndInactiveLevelDelayTimeValue'
    }
  };

  private inputSubjects = new Map<string, Subject<string>>();
  private inputSubscriptions: Subscription[] = [];
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private featureData: FeatureDataStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }
  ngOnInit() {
    this.isEdited = false;
    this.lineSwitchDefaultColor = true;
    this.getLineSwitchDefaultValueSub = this.featureDefaults.getLineSwitchDefaultValue.subscribe((response) => {
      if (response == "valid") {
        this.lineSwitchDefaultColor = true;
        this.isResetLineSwitch = true;
        this.resetDefaultLineSwitch();
      }
    });

    this.lineSwitchSub = this.featureData.getLineSwitchData.subscribe((data) => {
      if (data) {
        this.ngModelval = data;
        this.ngModelval["HighVLevelValue"] = data["HighVLevelValue"];
        this.ngModelval["lineswitchLowVLevelValue"] =
          data["lineswitchLowVLevelValue"];
        this.ngModelval["lineswitchFadeUpTimeValue"] =
          data["lineswitchFadeUpTimeValue"];
        this.ngModelval["lineswitchFadeDownValue"] =
          data["lineswitchFadeDownValue"];
        this.ngModelval["lineswitchOffDelayValue"] =
          data["lineswitchOffDelayValue"];
        this.ngModelval["2ndInactiveLevelEnabled"] =
          data["2ndInactiveLevelEnabled"];
        this.ngModelval["lineswitch2ndInactiveDimLevelValue"] =
          data["lineswitch2ndInactiveDimLevelValue"];
        this.ngModelval["lineswitch2ndInactiveLevelDelayTimeValue"] =
          data["lineswitch2ndInactiveLevelDelayTimeValue"];
        if (this.isResetLineSwitch) {
          this.isResetLineSwitch = false;
        } else {
          this.checkdfault();
        }
        this.checkInvalidValues();
        this.isInitialLoad = false;
      }
    });

    // Guard: If schema not loaded, initialize with safe defaults and return
    if (!this.field || !this.field.properties) {
      this.lineswitchHighVOption = { floor: 0, ceil: 100 };
      this.lineswitchLowVLevelOption = { floor: 0, ceil: 100 };
      this.lineswitchFadeUpTimeOption = { floor: 0, ceil: 100 };
      this.lineswitchFadeDownTimeOption = { floor: 0, ceil: 100 };
      this.lineswitchOffDelayTimeOption = { floor: 0, ceil: 100 };
      this.lineswitch2ndInactiveDimLevelOption = { floor: 0, ceil: 100 };
      this.lineswitch2ndInactiveLevelDelayTimeOption = { floor: 0, ceil: 100 };
      return;
    }

    this.featureVersion = this.field.featureVersion;
    this.column = this.field.requiredProperties;
    this.properties = this.changeKeys(this.field.properties);
    this.featureData.lineswitchInputError(false);
    this.HighVLevelNormal = this.properties.HighVLevel;
    this.lineswitchHighVLevelMin = this.HighVLevelNormal.minimum;
    this.lineswitchHighVLevelMax = this.HighVLevelNormal.maximum;
    this.ngModelval["HighVLevelValue"] = this.HighVLevelValue =
      this.HighVLevelNormal.default;
    this.HighVLevelDisplayValue = this.HighVLevelValue;
    this.lineswitchHighVOption = {
      floor: this.lineswitchHighVLevelMin,
      ceil: this.lineswitchHighVLevelMax,
    };
    this.LineSwitchEnabled = this.properties.LineSwitchEnabled;
    this.ngModelval["isLineSwitchEnabled"] = this.isLineSwitchEnabled =
      this.LineSwitchEnabled.default;
    this.lineswitchLowVLevel = this.properties.LowVLevel;
    this.lineswitchLowVLevelMin = this.lineswitchLowVLevel.minimum;
    this.lineswitchLowVLevelMax = this.lineswitchLowVLevel.maximum;
    this.ngModelval["lineswitchLowVLevelValue"] =
      this.lineswitchLowVLevelValue = this.lineswitchLowVLevel.default;
    this.lineswitchLowVLevelDisplayValue = this.lineswitchLowVLevelValue;
    this.lineswitchLowVLevelOption = {
      floor: this.lineswitchLowVLevelMin,
      ceil: this.lineswitchLowVLevelMax,
    };
    this.lineswitchFadeUpTime = this.properties.FadeUpTime;
    this.lineswitchFadeUpTimeMin = this.lineswitchFadeUpTime.minimum;
    this.lineswitchFadeUpTimeMax = this.lineswitchFadeUpTime.maximum;
    this.ngModelval["lineswitchFadeUpTimeValue"] =
      this.lineswitchFadeUpTimeValue = this.lineswitchFadeUpTime.default;
    this.lineswitchFadeUpTimeDisplayValue = this.lineswitchFadeUpTimeValue;
    this.lineswitchFadeUpTimeOption = {
      floor: this.lineswitchFadeUpTimeMin,
      ceil: this.lineswitchFadeUpTimeMax,
    };
    this.lineswitchFadeDownTime = this.properties.FadeDownTime;
    this.lineswitchFadeDownTimeMin = this.lineswitchFadeDownTime.minimum;
    this.lineswitchFadeDownTimeMax = this.lineswitchFadeDownTime.maximum;
    this.ngModelval["lineswitchFadeDownValue"] = this.lineswitchFadeDownValue =
      this.lineswitchFadeDownTime.default;
    this.lineswitchFadeDownDisplayValue = this.lineswitchFadeDownValue;
    this.lineswitchFadeDownTimeOption = {
      floor: this.lineswitchFadeDownTimeMin,
      ceil: this.lineswitchFadeDownTimeMax,
    };
    this.lineswitchOffDelayTime = this.properties.SwitchOffDelayTime;
    this.lineswitchOffDelayTimeMin = this.lineswitchOffDelayTime.minimum;
    this.lineswitchOffDelayTimeMax = this.lineswitchOffDelayTime.maximum;
    this.ngModelval["lineswitchOffDelayValue"] = this.lineswitchOffDelayValue =
      this.lineswitchOffDelayTime.default;
    this.lineswitchOffDelayDisplayValue = this.lineswitchOffDelayValue;
    this.lineswitchOffDelayTimeOption = {
      floor: this.lineswitchOffDelayTimeMin,
      ceil: this.lineswitchOffDelayTimeMax,
    };
    if (this.featureVersion === 4) {
      this.inactiveLevelEnabled = this.ngModelval["2ndInactiveLevelEnabled"] =
        this.properties.secondInactiveLevelEnabled.default;
      this.lineswitch2ndInactiveDimLevel =
        this.properties.secondInactiveDimLevel;
      this.lineswitch2ndInactiveDimLevelMin =
        this.lineswitch2ndInactiveDimLevel.minimum;
      this.lineswitch2ndInactiveDimLevelMax =
        this.lineswitch2ndInactiveDimLevel.maximum;
      this.ngModelval["lineswitch2ndInactiveDimLevelValue"] =
        this.lineswitch2ndInactiveDimLevelValue =
        this.lineswitch2ndInactiveDimLevel.default;
      this.lineswitch2ndInactiveDimLevelDisplayValue = this.lineswitch2ndInactiveDimLevelValue;
      this.lineswitch2ndInactiveDimLevelOption = {
        floor: this.lineswitch2ndInactiveDimLevelMin,
        ceil: this.lineswitch2ndInactiveDimLevelMax,
      };
      this.lineswitch2ndInactiveLevelDelayTime =
        this.properties.secondInactiveLevelDelayTime;
      this.lineswitch2ndInactiveLevelDelayTimeMin =
        this.lineswitch2ndInactiveLevelDelayTime.minimum;
      this.lineswitch2ndInactiveLevelDelayTimeMax =
        this.lineswitch2ndInactiveLevelDelayTime.maximum;
      this.ngModelval["lineswitch2ndInactiveLevelDelayTimeValue"] =
        this.lineswitch2ndInactiveLevelDelayTimeValue =
        this.lineswitch2ndInactiveLevelDelayTime.default;
      this.lineswitch2ndInactiveLevelDelayDisplayValue = this.lineswitch2ndInactiveLevelDelayTimeValue;
      this.lineswitch2ndInactiveLevelDelayTimeOption = {
        floor: this.lineswitch2ndInactiveLevelDelayTimeMin,
        ceil: this.lineswitch2ndInactiveLevelDelayTimeMax,
      };
    }
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (
          element != null &&
          element["featureName"] != null &&
          element["featureName"].toString().toUpperCase() === "LINESWITCH"
        ) {
          isConfigEdited = true;
          const LINESWITCH: LegacyAny = element["featureParameters"][0];
          this.addlineSwitchLoadedFeatureReadValues(LINESWITCH);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    if (!isConfigEdited) {
      //setTimeout(() => {
        // Use centralized method to get feature data (prioritizes SaveSetData over ConfigurationData)
        const lineSwitchData = this.appState.getFeatureData('LineSwitch') || this.appState.getFeatureData('Lineswitch');
        if (lineSwitchData) {
          this.addlineSwitchLoadedFeatureReadValues(lineSwitchData);
        }
      //}, 1000);
    }
    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox textBoxUnit";
        this.setQuickConfig = "quickConfig";
      } else if (data === "standard") {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
    //setTimeout(() => {
      this.sendLineSwitchdata();
    //}, 1000);

    Object.keys(this.fieldConfig).forEach(fieldName => {
      const subject = new Subject<string>();
      this.inputSubjects.set(fieldName, subject);

      this.inputSubscriptions.push(
        subject.pipe(
          debounceTime(50),
          distinctUntilChanged()
        ).subscribe(value => {
          this.validateAndUpdateField(fieldName, value);
        })
      );
    });

  }

  sendLineSwitchdata() {
    this.featureData.sendLineSwitchdata(this.ngModelval);
    this.setConfigurationData(this.ngModelval, 'LineSwitch');
  };

  setConfigurationData(value, keyVal) {
    if(value != null){
      // Use centralized method to save feature data
      // This automatically saves to both ConfigurationData and SaveSetData
      const lineSwitchObj = Object.assign({}, value);
      this.appState.setFeatureData(keyVal, lineSwitchObj);
    }
  }


  toggleIsLineSwitchEnabled(isChecked: boolean) {
    this.ngModelval["isLineSwitchEnabled"] = this.isLineSwitchEnabled =
      isChecked;
    this.sendLineSwitchdata();
    this.checkdfault();
    this.checkInvalidValues();
  }
  addlineSwitchLoadedFeatureReadValues(lineSwitch: LegacyAny) {
    const lineSwitchObj = lineSwitch;
    const keys = Object.keys(lineSwitchObj);
    const values = Object.values(lineSwitchObj);
    keys.forEach((key, i) => {
      this.textValChanged(values[i], key);
    });
    const result: LegacyAny = {};
    keys.forEach((key, i) => (result[key] = values[i]));
    this.ngModelval = result;
    this.ngModelval["HighVLevelValue"] = result["HighVLevelValue"] != null ? result["HighVLevelValue"] : result["HighVLevel"];
    this.isLineSwitchEnabled = this.ngModelval["isLineSwitchEnabled"] = result["LineSwitchEnabled"] !== undefined ? result["LineSwitchEnabled"] : result["isLineSwitchEnabled"];
    this.HighVLevelValue = result["HighVLevelValue"] != null ? result["HighVLevelValue"] : result["HighVLevel"];
    this.HighVLevelDisplayValue = this.HighVLevelValue;
    this.ngModelval["lineswitchLowVLevelValue"] = result["lineswitchLowVLevelValue"] != null ? result["lineswitchLowVLevelValue"] : result["LowVLevel"];
    this.lineswitchLowVLevelValue = result["lineswitchLowVLevelValue"] != null ? result["lineswitchLowVLevelValue"] : result["LowVLevel"];
    this.lineswitchLowVLevelDisplayValue = this.lineswitchLowVLevelValue;
    this.ngModelval["lineswitchFadeUpTimeValue"] = result["lineswitchFadeUpTimeValue"] != null ? result["lineswitchFadeUpTimeValue"] : result["FadeUpTime"];
    this.lineswitchFadeUpTimeValue = result["lineswitchFadeUpTimeValue"] != null ? result["lineswitchFadeUpTimeValue"] : result["FadeUpTime"];
    this.lineswitchFadeUpTimeDisplayValue = this.lineswitchFadeUpTimeValue;
    this.ngModelval["lineswitchFadeDownValue"] = result["lineswitchFadeDownValue"] != null ? result["lineswitchFadeDownValue"] : result["FadeDownTime"];
    this.lineswitchFadeDownValue = result["lineswitchFadeDownValue"] != null ? result["lineswitchFadeDownValue"] : result["FadeDownTime"];
    this.lineswitchFadeDownDisplayValue = this.lineswitchFadeDownValue;
    this.ngModelval["lineswitchOffDelayValue"] = result["lineswitchOffDelayValue"] != null ? result["lineswitchOffDelayValue"] : result["SwitchOffDelayTime"];
    this.lineswitchOffDelayValue = result["lineswitchOffDelayValue"] != null ? result["lineswitchOffDelayValue"] : result["SwitchOffDelayTime"];
    this.lineswitchOffDelayDisplayValue = this.lineswitchOffDelayValue;

    if (result.hasOwnProperty("2ndInactiveLevelEnabled")) {
      this.inactiveLevelEnabled = this.ngModelval["2ndInactiveLevelEnabled"];
      this.ngModelval["2ndInactiveLevelEnabled"] =
        result["2ndInactiveLevelEnabled"];
    } else {
      this.show2ndInactiveLevelEnabled = false;
    }
    if (result.hasOwnProperty("2ndInactiveDimLevel") || result.hasOwnProperty("lineswitch2ndInactiveDimLevelValue")) {
      this.ngModelval["lineswitch2ndInactiveDimLevelValue"] =
      result["lineswitch2ndInactiveDimLevelValue"] != null ? result["lineswitch2ndInactiveDimLevelValue"] : result["2ndInactiveDimLevel"];
      this.lineswitch2ndInactiveDimLevelValue = result["lineswitch2ndInactiveDimLevelValue"] != null ? result["lineswitch2ndInactiveDimLevelValue"] : result["2ndInactiveDimLevel"];
      this.lineswitch2ndInactiveDimLevelDisplayValue = this.lineswitch2ndInactiveDimLevelValue;
    } else {
      this.show2ndInactiveDimLevel = false;
    }
    if (result.hasOwnProperty("2ndInactiveLevelDelayTime") || result.hasOwnProperty("lineswitch2ndInactiveLevelDelayTimeValue")) {
      this.ngModelval["lineswitch2ndInactiveLevelDelayTimeValue"] =
      result["lineswitch2ndInactiveLevelDelayTimeValue"] != null ? result["lineswitch2ndInactiveLevelDelayTimeValue"] : result["2ndInactiveLevelDelayTime"];
      this.lineswitch2ndInactiveLevelDelayTimeValue =
      result["lineswitch2ndInactiveLevelDelayTimeValue"] != null ? result["lineswitch2ndInactiveLevelDelayTimeValue"] : result["2ndInactiveLevelDelayTime"];
      this.lineswitch2ndInactiveLevelDelayDisplayValue = this.lineswitch2ndInactiveLevelDelayTimeValue;
    } else {
      this.show2ndInactiveLevelDelayTime = false;
    }
    this.checkdfault();
    this.checkInvalidValues();
    this.sendLineSwitchdata();
  }
  changeKeys(originalObj) {
    const replacements = {
      "2ndInactiveDimLevel": "secondInactiveDimLevel",
      "2ndInactiveLevelDelayTime": "secondInactiveLevelDelayTime",
      "2ndInactiveLevelEnabled": "secondInactiveLevelEnabled",
    };
    const replacedItems = Object.keys(originalObj).map((key) => {
      const newKey = replacements[key] || key;
      return { [newKey]: originalObj[key] };
    });
    return replacedItems.reduce((a, b) => Object.assign({}, a, b));
  }
  enableLevel2(value) {
    this.inactiveLevelEnabled = value;
    this.ngModelval["2ndInactiveLevelEnabled"] = value;
    this.sendLineSwitchdata();
  }




  onFieldInput(fieldName: string, value: string) {
    const config = this.fieldConfig[fieldName];
    if (!config) return;
    if (value === '') {
      this[config.displayKey] = '';
      this[config.valueKey] = null;
      if (config.ngModelKey) {
        this.ngModelval[config.ngModelKey] = null;
      } else {
        this.ngModelval[config.modelKey] = null;
      }
      this.inputError[fieldName] = true;
      this.lineSwitchDefaultColor = false;
      this.checkInvalidValues();
      this.sendLineSwitchdata();
      return;
    }
    const numValue = parseInt(value);
    if (!isNaN(numValue)) {
      this[config.displayKey] = numValue;
      this[config.valueKey] = numValue;
      if (config.ngModelKey) {
        this.ngModelval[config.ngModelKey] = numValue;
      } else {
        this.ngModelval[config.modelKey] = numValue;
      }

      const minValue = this[config.minKey];
      const maxValue = this[config.maxKey];
      if (numValue >= minValue && numValue <= maxValue) {
        this.inputError[fieldName] = false;
        this.lineSwitchDefaultColor = false;
        this.checkdfault();
        this.checkInvalidValues();
      } else {
        this.inputError[fieldName] = true;
        this.lineSwitchDefaultColor = false;
        this.checkInvalidValues();
      }

      if (this.ref && !(this.ref as ViewRef).destroyed) {
        this.ref.detectChanges();
      }
    } else {
      this[config.displayKey] = '';
      this.inputError[fieldName] = true;
      this.lineSwitchDefaultColor = false;
      this.checkInvalidValues();
    }
    this[config.displayKey] =  isNaN(numValue)? '' : numValue;
    this.validateAndUpdateField(fieldName, value);
    const subject = this.inputSubjects.get(fieldName);
    if (subject) {
      subject.next(value);
    }
  }



  onFieldBlur(fieldName: string, value: string) {
    this.validateAndUpdateField(fieldName, value);
  }

  private validateAndUpdateField(fieldName: string, value: string) {
    const config = this.fieldConfig[fieldName];
    if (!config) return;
    if (value === '') {
      this.inputError[fieldName] = true;
      this[config.displayKey] = '';
      this[config.valueKey] = null;
      if (config.ngModelKey) {
        this.ngModelval[config.ngModelKey] = null;
      } else {
        this.ngModelval[config.modelKey] = null;
      }
      this.sendLineSwitchdata();
      return;
    }
    const numValue = parseInt(value);

    if (isNaN(numValue)) {
      this.inputError[fieldName] = true;
      return;
    }
    const minValue = this[config.minKey];
    const maxValue = this[config.maxKey];
    let clampedValue = numValue;
    let isOutOfRange = false;
    if (numValue < minValue) {
      clampedValue = minValue;
      isOutOfRange = true;
    } else if (numValue > maxValue) {
      clampedValue = maxValue;
      isOutOfRange = true;
    }

    const currentValue = this[config.valueKey];
    if (currentValue !== clampedValue) {
      this[config.valueKey] = clampedValue;
      if (config.ngModelKey) {
        this.ngModelval[config.ngModelKey] = clampedValue;
      } else {
        this.ngModelval[config.modelKey] = clampedValue;
      }
    }


    if (isOutOfRange) {
      this[config.displayKey] = numValue;
      this.inputError[fieldName] = true;
    } else {
      this[config.displayKey] = clampedValue;
      this.inputError[fieldName] = false;
    }

    this.lineSwitchDefaultColor = false;
    this.checkdfault();
    this.checkInvalidValues();
    this.sendLineSwitchdata();
  }

  private onSliderChange(fieldName: string, value: number) {
    const config = this.fieldConfig[fieldName];
    if (!config) return;

    this.inputError[fieldName] = false;

    const minValue = this[config.minKey];
    if (value >= minValue) {
      this[config.valueKey] = value;
      this[config.displayKey] = value;

      if (config.ngModelKey) {
        this.ngModelval[config.ngModelKey] = value;
      } else {
        this.ngModelval[config.modelKey] = value;
      }

      this.sendLineSwitchdata();
      this.checkdfault();
      this.checkInvalidValues();
    }
  }

  onHighVLevelInput(value: string) {
    this.onFieldInput('HighVLevel', value);
  }

  onHighVLevelBlur(value: string) {
    this.onFieldBlur('HighVLevel', value);
  }

  onLowVLevelInput(value: string) {
    this.onFieldInput('LowVLevel', value);
  }

  onLowVLevelBlur(value: string) {
    this.onFieldBlur('LowVLevel', value);
  }

  onFadeUpTimeInput(value: string) {
    this.onFieldInput('FadeUpTime', value);
  }

  onFadeUpTimeBlur(value: string) {
    this.onFieldBlur('FadeUpTime', value);
  }

  onFadeDownTimeInput(value: string) {
    this.onFieldInput('FadeDownTime', value);
  }

  onFadeDownTimeBlur(value: string) {
    this.onFieldBlur('FadeDownTime', value);
  }

  onSwitchOffDelayTimeInput(value: string) {
    this.onFieldInput('SwitchOffDelayTime', value);
  }

  onSwitchOffDelayTimeBlur(value: string) {
    this.onFieldBlur('SwitchOffDelayTime', value);
  }

  on2ndInactiveDimLevelInput(value: string) {
    this.onFieldInput('2ndInactiveDimLevel', value);
  }

  on2ndInactiveDimLevelBlur(value: string) {
    this.onFieldBlur('2ndInactiveDimLevel', value);
  }

  on2ndInactiveLevelDelayTimeInput(value: string) {
    this.onFieldInput('2ndInactiveLevelDelayTime', value);
  }

  on2ndInactiveLevelDelayTimeBlur(value: string) {
    this.onFieldBlur('2ndInactiveLevelDelayTime', value);
  }


  lineswitchHighVValueChange(value) {
    this.onSliderChange('HighVLevel', value);
  }
  lineswitchLowVLevelChange(value) {
    this.onSliderChange('LowVLevel', value);
  }
  lineswitchFadeUpTimeChange(value) {
    this.onSliderChange('FadeUpTime', value);
  }
  lineswitchFadeDownTimeChange(value) {
    this.onSliderChange('FadeDownTime', value);
  }
  lineSwitchoffDelayTimeChange(value) {
    this.onSliderChange('SwitchOffDelayTime', value);
  }
  lineswitch2ndInactiveDimLevelChange(value) {
    this.onSliderChange('2ndInactiveDimLevel', value);
  }
  lineswitch2ndInactiveLevelDelayTimeChange(value) {
    this.onSliderChange('2ndInactiveLevelDelayTime', value);
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  textValChanged(value, colName) {
    value = parseInt(value);
    if (this.fieldConfig[colName]) {
      return;
    }
    if (colName !== "2ndInactiveLevelEnabled" && colName !== "LineSwitchEnabled" && colName !== "isLineSwitchEnabled"
      && (isNaN(value) || value.length === 0)) {
      this.inputError[colName] = true;
    } else {
      this.lineSwitchDefaultColor = false;
      this.inputError[colName] = false;
      this.lineswitchCreateFile = false;
      if (colName == "LowVLevel") {
        if (
          value < this.lineswitchLowVLevelMin ||
          value > this.lineswitchLowVLevelMax
        ) {
          this.inputError[colName] = true;
          this.ngModelval["lineswitchLowVLevelValue"] = value;
        } else {
          this.lineswitchLowVLevelValue = value;
          this.ngModelval["lineswitchLowVLevelValue"] = value;
        }
      } else if (colName == "FadeUpTime") {
        if (
          value < this.lineswitchFadeUpTimeMin ||
          value > this.lineswitchFadeUpTimeMax
        ) {
          this.inputError[colName] = true;
          this.ngModelval["lineswitchFadeUpTimeValue"] = value;
        } else {
          this.lineswitchFadeUpTimeValue = value;
          this.ngModelval["lineswitchFadeUpTimeValue"] = value;
        }
      } else if (colName == "FadeDownTime") {
        if (
          value < this.lineswitchFadeDownTimeMin ||
          value > this.lineswitchFadeDownTimeMax
        ) {
          this.inputError[colName] = true;
          this.ngModelval["lineswitchFadeDownValue"] = value;
        } else {
          this.lineswitchFadeDownValue = value;
          this.ngModelval["lineswitchFadeDownValue"] = value;
        }
      } else if (colName == "SwitchOffDelayTime") {
        if (
          value < this.lineswitchOffDelayTimeMin ||
          value > this.lineswitchOffDelayTimeMax
        ) {
          this.inputError[colName] = true;
          this.ngModelval["lineswitchOffDelayValue"] = value;
        } else {
          this.lineswitchOffDelayValue = value;
          this.ngModelval["lineswitchOffDelayValue"] = value;
        }
      } else if (colName == "2ndInactiveDimLevel") {
        if (
          value < this.lineswitch2ndInactiveDimLevelMin ||
          value > this.lineswitch2ndInactiveDimLevelMax
        ) {
          this.inputError[colName] = true;
          this.ngModelval["lineswitch2ndInactiveDimLevelValue"] = value;
        } else {
          this.lineswitch2ndInactiveDimLevelValue = value;
          this.ngModelval["lineswitch2ndInactiveDimLevelValue"] = value;
        }
      } else if (colName == "2ndInactiveLevelDelayTime") {
        if (
          value < this.lineswitch2ndInactiveLevelDelayTimeMin ||
          value > this.lineswitch2ndInactiveLevelDelayTimeMax
        ) {
          this.inputError[colName] = true;
          this.ngModelval["lineswitch2ndInactiveLevelDelayTimeValue"] = value;
        } else {
          this.lineswitch2ndInactiveLevelDelayTimeValue = value;
          this.ngModelval["lineswitch2ndInactiveLevelDelayTimeValue"] = value;
        }
      }
    }
    this.checkdfault();
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.lineswitchCreateFile = true;
      }
    }
    this.featureData.lineSwitchEditedVal(this.lineSwitchDefaultColor);
    this.featureData.lineswitchInputError(this.lineswitchCreateFile);
    this.sendLineSwitchdata();
  }
  checkdfault() {
    let newtype;
    let newtype2;
    let newtype3;
    this.lineSwitchDefaultColor = true;

    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.lineSwitchDefaultColor = false;
        if (!this.isInitialLoad) {
          this.featureData.lineSwitchEditedVal(this.lineSwitchDefaultColor);
        }
        return;
      }
    }

    this.properties = this.changeKeys(this.field.properties);
    for (const type in this.ngModelval) {
      if (type == "HighVLevelValue") {
        newtype = type.replace("Value", "");
        if (this.ngModelval[type] != this.properties[newtype]["default"]) {
          this.lineSwitchDefaultColor = false;
        }
      } else if (
        type == "lineswitchLowVLevelValue" ||
        type == "lineswitchFadeUpTimeValue"
      ) {
        newtype = type.replace("lineswitch", "");
        newtype2 = newtype.replace("Value", "");
        if (this.ngModelval[type] != this.properties[newtype2]["default"]) {
          this.lineSwitchDefaultColor = false;
        }
      } else if (type == "lineswitchFadeDownValue") {
        newtype = type.replace("lineswitch", "");
        newtype2 = newtype.replace("Value", "Time");
        if (this.ngModelval[type] != this.properties[newtype2]["default"]) {
          this.lineSwitchDefaultColor = false;
        }
      } else if (type == "lineswitchOffDelayValue") {
        newtype = type.replace("lineswitchOffDelayValue", "SwitchOffDelayTime");
        if (this.ngModelval[type] != this.properties[newtype]["default"]) {
          this.lineSwitchDefaultColor = false;
        }
      } else if (type == "2ndInactiveLevelEnabled") {
        newtype = type.replace("2", "seco");
        if (this.properties.hasOwnProperty(newtype)) {
          if (this.ngModelval[type] != this.properties[newtype]["default"]) {
            this.lineSwitchDefaultColor = false;
          }
        }
      } else if (
        type == "lineswitch2ndInactiveDimLevelValue" ||
        type == "lineswitch2ndInactiveLevelDelayTimeValue"
      ) {
        newtype = type.replace("lineswitch", "");
        newtype2 = newtype.replace("Value", "");
        newtype3 = newtype2.replace("2", "seco");
        if (this.properties.hasOwnProperty(newtype3)) {
          if (this.ngModelval[type] != this.properties[newtype3]["default"]) {
            this.lineSwitchDefaultColor = false;
          }
        }
      } else if (type == "isLineSwitchEnabled") {
        newtype = type.replace("isLineSwitchEnabled", "LineSwitchEnabled");
        if (
          this.properties[newtype]["default"] != null &&
          this.ngModelval[type] != this.properties[newtype]["default"]
        ) {
          this.lineSwitchDefaultColor = false;
        }
      }
    }
    if (!this.isInitialLoad) {
      this.featureData.lineSwitchEditedVal(this.lineSwitchDefaultColor);
    }
  }
  checkInvalidValues() {
    this.lineswitchCreateFile = false;
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.lineswitchCreateFile = true;
      }
    }
    this.featureData.lineswitchInputError(this.lineswitchCreateFile);
  }
  sliderEvent(option?) { }
  resetDefaultLineSwitch() {
    this.enableLevel2(false);
    this.ngModelval["HighVLevelValue"] = this.HighVLevelValue =
      this.HighVLevelNormal.default;
    this.HighVLevelDisplayValue = this.HighVLevelNormal.default;

    this.ngModelval["lineswitchLowVLevelValue"] =
      this.lineswitchLowVLevelValue = this.lineswitchLowVLevel.default;
    this.lineswitchLowVLevelDisplayValue = this.lineswitchLowVLevel.default;

    if (this.LineSwitchEnabled.default != null) {
      this.ngModelval["isLineSwitchEnabled"] = this.isLineSwitchEnabled =
        this.LineSwitchEnabled.default;
    }
    if (this.lineswitchFadeUpTime.default != null) {
      this.ngModelval["lineswitchFadeUpTimeValue"] =
        this.lineswitchFadeUpTimeValue = this.lineswitchFadeUpTime.default;
      this.lineswitchFadeUpTimeDisplayValue = this.lineswitchFadeUpTime.default;
    }
    if (this.lineswitchFadeDownTime.default != null) {
      this.ngModelval["lineswitchFadeDownValue"] =
        this.lineswitchFadeDownValue = this.lineswitchFadeDownTime.default;
      this.lineswitchFadeDownDisplayValue = this.lineswitchFadeDownTime.default;
    }
    if (this.lineswitchOffDelayTime.default != null) {
      this.ngModelval["lineswitchOffDelayValue"] =
        this.lineswitchOffDelayValue = this.lineswitchOffDelayTime.default;
      this.lineswitchOffDelayDisplayValue = this.lineswitchOffDelayTime.default;
    }
    if (
      this.properties.secondInactiveLevelEnabled != null &&
      this.properties.secondInactiveLevelEnabled.default != null
    ) {
      this.ngModelval["2ndInactiveLevelEnabled"] =
        this.properties.secondInactiveLevelEnabled.default;
    }
    if (
      this.lineswitch2ndInactiveLevelDelayTime != null &&
      this.lineswitch2ndInactiveLevelDelayTime.default != null
    ) {
      this.ngModelval["lineswitch2ndInactiveLevelDelayTimeValue"] =
        this.lineswitch2ndInactiveLevelDelayTimeValue =
          this.lineswitch2ndInactiveLevelDelayTime.default;
      this.lineswitch2ndInactiveLevelDelayDisplayValue = this.lineswitch2ndInactiveLevelDelayTime.default;
    }
    if (
      this.lineswitch2ndInactiveDimLevel != null &&
      this.lineswitch2ndInactiveDimLevel.default != null
    ) {
      this.ngModelval["lineswitch2ndInactiveDimLevelValue"] =
        this.lineswitch2ndInactiveDimLevelValue =
        this.lineswitch2ndInactiveDimLevel.default;
      this.lineswitch2ndInactiveDimLevelDisplayValue = this.lineswitch2ndInactiveDimLevel.default;
    }
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.lineswitchCreateFile = false;
    this.featureData.lineswitchInputError(this.lineswitchCreateFile);
    this.sendLineSwitchdata();
    this.ref.markForCheck();
  }
  ngOnDestroy() {
    this.featureDefaults.setLineSwitchDefaultColor("");
    if (this.lineSwitchSub) {
      this.lineSwitchSub.unsubscribe();
    };
    if (this.getLineSwitchDefaultValueSub) {
      this.getLineSwitchDefaultValueSub.unsubscribe();
    }
    this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());
  }
}

